import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { FeaturedWork } from "@/components/FeaturedWork";
import { Services } from "@/components/Services";
import { C3Framework } from "@/components/C3Framework";
import { SelectedWork } from "@/components/SelectedWork";
import { Philosophy } from "@/components/Philosophy";
import { Contact } from "@/components/Contact";

const Footer = () => (
  <footer data-testid="footer" className="bg-deep-black text-white py-12">
    <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div>
        <span className="font-heading text-lg tracking-[0.02em] uppercase">
          <span className="font-bold">LMT</span>{" "}
          <span className="font-light">SPARK</span>
        </span>
        <p className="font-body text-xs text-white/40 mt-2 font-light">
          Creative & Commercial Consultancy
        </p>
      </div>
      <p className="font-body text-xs text-white/30 font-light">
        &copy; {new Date().getFullYear()} LMT Spark. All rights reserved.
      </p>
    </div>
  </footer>
);

function App() {
  return (
    <div className="min-h-screen bg-off-white">
      <Header />
      {/* Sticky HOLT Tab */}
      <a
        href="https://houseofltoys.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="holt-sticky-tab"
        className="fixed top-0 right-3 z-[60] w-12 h-12 rounded-bl-lg shadow-lg overflow-hidden hover:scale-110 transition-transform duration-300"
      >
        <img
          src="https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/2taa7462_HOLTTAB%202.png"
          alt="House of L Toys"
          className="w-full h-full object-cover"
        />
      </a>
      <main>
        <Hero />
        <FeaturedWork />
        <Services />
        <C3Framework />
        <SelectedWork />
        <Philosophy />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
